import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { RouterView, type RouterOptions } from "vue-router";
import { dustEnforcementActionRouteName } from "../enforcementAction/enforcementAction";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustEnforcementActions: "DustEnforcementAction.DustEnforcementActions",
  list: "DustEnforcementAction.DustEnforcementActionsList",
  new: "DustEnforcementAction.DustEnforcementActionNew",
  base: "DustEnforcementAction.DustEnforcementActionBase",
  view: "DustEnforcementAction.DustEnforcementActionView",
  edit: "DustEnforcementAction.DustEnforcementActionEdit",
  documents: "DustEnforcementAction.DustEnforcementActionDocuments",
  documentsEdit: "DustEnforcementAction.DustEnforcementActionDocumentsEdit",
  documentsNew: "DustEnforcementAction.DustEnforcementActionDocumentsNew",
  audit: "DustEnforcementAction.DustEnforcementActionAudit",
};

export { names as dustEnforcementActionRouteNames };

const dustEnforcementActionRoutes: RouterOptions["routes"] = [
  {
    path: "/dustEnforcementAction",
    name: names.dustEnforcementActions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Enforcement Actions",
          lookupGroups: ["DeliveryMethod", "EnforcementActionType", "InspectionCategory"],
        },
        component: () => import("@/views/dustEnforcementActions/DustEnforcementActionsList.vue"),
      },
      {
        path: "new/:inspectionId(\\d+)?",
        component: () => import("@/views/dustEnforcementActions/DustEnforcementActionBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Enforcement Action", isNew: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: dustEnforcementActionRouteName },
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/dustEnforcementActions/DustEnforcementActionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Dust Enforcement Action View" },
            component: () => import("@/views/enforcementAction/EnforcementActionView.vue"),
            props: { entityRouteName: dustEnforcementActionRouteName },
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Dust Enforcement Action Edit", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: dustEnforcementActionRouteName },
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Dust Enforcement Action Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="dustEnforcementAction" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Dust Enforcement Action Document", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocument.vue"),
            props: { resourceTypeKey: "dustEnforcementAction" },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Dust Enforcement Action Documents", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocuments.vue"),
            props: { resourceTypeKey: "dustEnforcementAction" },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Dust Enforcement Action Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="EnforcementAction" />,
            },
          },
        ],
      },
    ],
  },
];
export default dustEnforcementActionRoutes;
